export const getUserAcronym = (fullname: string) => {
  if (!fullname) {
    return "W";
  }

  const words = fullname.split(" ");
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};
